import { render, staticRenderFns } from "./HgFarmerProximity.vue?vue&type=template&id=e1470f5e&scoped=true"
import script from "./HgFarmerProximity.vue?vue&type=script&lang=js"
export * from "./HgFarmerProximity.vue?vue&type=script&lang=js"
import style0 from "./HgFarmerProximity.vue?vue&type=style&index=0&id=e1470f5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1470f5e",
  null
  
)

export default component.exports